@if (rights.includes('CM')) {
  <div>
    <div class="table-label"> Aging Cases </div>
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th></th>
            @for (header of headers; track header.label) {
              <th>{{ header.label }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @if (cases && cases.length > 0) {
            @for (case of cases; track case.CRID) {
              <tr>
                <td>
                  <button
                    type="button"
                    mat-icon-button
                    class="fs-button"
                    color="primary"
                    matTooltip="View Case"
                    (click)="viewCase(case.CRID)"
                  >
                    <mat-icon>preview</mat-icon>
                  </button>
                </td>
                @for (varRef of headers; track varRef.label) {
                  @if (varRef.dataMask === 'date') {
                    <td>{{ case[varRef.varName] | localTime: 'shortDate' }}</td>
                  } @else {
                    <td>{{ case[varRef.varName] }}</td>
                  }
                }
              </tr>
            }
          } @else {
            <tr>
              <td colspan="8" class="no-records"> No Records found </td>
            </tr>
          }
        </tbody>
      </table>

      <ngx-loading
        [show]="ptSvc.loading()"
        [config]="{ fullScreenBackdrop: false }"
      />
    </div>
  </div>
}
